import { jsxs as l, jsx as r } from "react/jsx-runtime";
const i = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: [
      /* @__PURE__ */ r(
        "path",
        {
          fill: "currentColor",
          d: "M4.894 5.468a.77.77 0 1 0 0-1.54.77.77 0 0 0 0 1.54Z"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          fill: "currentColor",
          d: "m12.41 9.093-3.348 3.34-5.988-5.988.411-2.974 2.932-.38 5.993 5.998 1.673-.448-7.127-7.133-4.8.623-.67 4.847 7.574 7.575 3.798-3.788-.448-1.672Z"
        }
      )
    ]
  }
);
export {
  i as Pricing
};
